export const secondsToMinutes = (seconds: number) => seconds / 60
export const minutesToSeconds = (minutes: number) => minutes * 60